if($('.in-index').length){
    if($('.welcome p img[style="float: right;"]').length){
        $('.welcome>div').wrapInner('<div class="right"></div>');
        $('.welcome>div').prepend($('.welcome p img[style="float: right;"]').closest('p'))
    }

    $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'>"+$(this).find('img').attr('alt')+"</li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'>"+$(this).find('img').attr('alt')+"</li>");
          });
        });
    });
    let startX = 0;

    $('#carousel').on('touchstart', function(e) {
        startX = e.originalEvent.touches[0].clientX;
    });

    $('#carousel').on('touchend', function(e) {
        let endX = e.originalEvent.changedTouches[0].clientX;
        if (startX - endX > 50) {
            $('#carousel').carousel('next');
        } else if (endX - startX > 50) {
            $('#carousel').carousel('prev');
        }
    });


}

